var map = {
	"./fortuneIcon.svg": 766,
	"./fortuneIconL.svg": 767,
	"./helpdeskIcon.svg": 768,
	"./helpdeskIconL.svg": 769,
	"./homeIcon.svg": 770,
	"./homeIconLarge.svg": 771,
	"./jackpotIcon.svg": 772,
	"./logo.svg": 773,
	"./logoSmall.svg": 774,
	"./lotteryIcon.svg": 775,
	"./loyaltyIcon.svg": 776,
	"./mobileAppIcon.svg": 777,
	"./profileIcon.svg": 778,
	"./questIcon.svg": 779,
	"./questsIcon.svg": 780,
	"./rewardLineupIcon.svg": 781,
	"./searchIcon.svg": 782,
	"./searchIconLarge.svg": 783,
	"./signOutIcon.svg": 784,
	"./star.svg": 785,
	"./tournamentIcon.svg": 786,
	"./tournamentLargeIcon.svg": 787,
	"./vipIcon.svg": 788,
	"./wheelIcon.svg": 789,
	"./wheelIconL.svg": 790,
	"./wheelIconMobile.svg": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;